/**
 * Данное число было получено от ios приложения.
 * Это максимальная высота отступа блока с имен,
 * через знания данной высоты как я понял от ios
 * меняем background у кнопок.
 */
const maxScrollChangeFactor = 80

export const findBackgroundImage = (
  scrollY: number,
  maxLength: number
): number => {
  const last = maxLength - 1

  if (scrollY > 0) {
    const index = Math.trunc(
      Math.min(scrollY / (maxScrollChangeFactor / last), last)
    )

    return index
  }

  return -1
}

export const findLastImage = (
  backgrounds: string[],
  backgroundsShadow: string[]
) => {
  return `url(${backgrounds[backgrounds.length - 1]}), url(${
    backgroundsShadow[backgroundsShadow.length - 1]
  })`
}
